import React from 'react';

import { DropdownButton } from '@ergeon/core-components';

type DropdownItem = {
  label: string;
  onClick: () => void;
  selected: boolean;
};

type FilterDropdownProps = {
  icon: React.ComponentType<{className?: string}>;
  items: DropdownItem[];
  label: string;
  title: string;
  alignment?: 'left' | 'right';
};

const FilterDropdown: React.FC<FilterDropdownProps> = ({ icon: Icon, items, label, title, alignment = 'left' }) => (
  <DropdownButton
    alignment={alignment}
    flavor="regular"
    hideChevron={false}
    icon={<Icon className="size-4" />}
    items={items}
    label={label}
    size="small"
    taste="boundless"
    title={title} />
);

export default FilterDropdown;
